"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TradeTrustTokenMock__factory = void 0;

var _ethers = require("ethers");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const _abi = [{
  inputs: [{
    internalType: "string",
    name: "name",
    type: "string"
  }, {
    internalType: "string",
    name: "symbol",
    type: "string"
  }, {
    internalType: "address",
    name: "escrowFactory",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "constructor"
}, {
  inputs: [],
  name: "InvalidAdminAddress",
  type: "error"
}, {
  inputs: [],
  name: "InvalidTokenId",
  type: "error"
}, {
  inputs: [],
  name: "TokenExists",
  type: "error"
}, {
  inputs: [],
  name: "TokenNotSurrendered",
  type: "error"
}, {
  inputs: [],
  name: "TransferFailure",
  type: "error"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Paused",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "previousAdminRole",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "bytes32",
    name: "newAdminRole",
    type: "bytes32"
  }],
  name: "RoleAdminChanged",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleGranted",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    indexed: true,
    internalType: "address",
    name: "account",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "sender",
    type: "address"
  }],
  name: "RoleRevoked",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: true,
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    indexed: true,
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    indexed: true,
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "Transfer",
  type: "event"
}, {
  anonymous: false,
  inputs: [{
    indexed: false,
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "Unpaused",
  type: "event"
}, {
  inputs: [],
  name: "ACCEPTER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "DEFAULT_ADMIN_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "MINTER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "RESTORER_ROLE",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "owner",
    type: "address"
  }],
  name: "balanceOf",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "burn",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "burnInternal",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "genesis",
  outputs: [{
    internalType: "uint256",
    name: "",
    type: "uint256"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }],
  name: "getRoleAdmin",
  outputs: [{
    internalType: "bytes32",
    name: "",
    type: "bytes32"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "grantRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "hasRole",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "beneficiary",
    type: "address"
  }, {
    internalType: "address",
    name: "holder",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "mint",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "mintInternal",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "name",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "address",
    name: "",
    type: "address"
  }, {
    internalType: "uint256",
    name: "",
    type: "uint256"
  }, {
    internalType: "bytes",
    name: "",
    type: "bytes"
  }],
  name: "onERC721Received",
  outputs: [{
    internalType: "bytes4",
    name: "",
    type: "bytes4"
  }],
  stateMutability: "pure",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "ownerOf",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "pause",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "paused",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "renounceRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "restore",
  outputs: [{
    internalType: "address",
    name: "",
    type: "address"
  }],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "address",
    name: "account",
    type: "address"
  }],
  name: "revokeRole",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "string",
    name: "baseURI",
    type: "string"
  }],
  name: "setBaseURI",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes32",
    name: "role",
    type: "bytes32"
  }, {
    internalType: "bytes32",
    name: "adminRole",
    type: "bytes32"
  }],
  name: "setRoleAdmin",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [{
    internalType: "bytes4",
    name: "interfaceId",
    type: "bytes4"
  }],
  name: "supportsInterface",
  outputs: [{
    internalType: "bool",
    name: "",
    type: "bool"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "symbol",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [],
  name: "titleEscrowFactory",
  outputs: [{
    internalType: "contract ITitleEscrowFactory",
    name: "",
    type: "address"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "tokenURI",
  outputs: [{
    internalType: "string",
    name: "",
    type: "string"
  }],
  stateMutability: "view",
  type: "function"
}, {
  inputs: [{
    internalType: "address",
    name: "from",
    type: "address"
  }, {
    internalType: "address",
    name: "to",
    type: "address"
  }, {
    internalType: "uint256",
    name: "tokenId",
    type: "uint256"
  }],
  name: "transferFrom",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}, {
  inputs: [],
  name: "unpause",
  outputs: [],
  stateMutability: "nonpayable",
  type: "function"
}];
const _bytecode = "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";

const isSuperArgs = xs => xs.length > 1;

class TradeTrustTokenMock__factory extends _ethers.ContractFactory {
  constructor(...args) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  deploy(name, symbol, escrowFactory, overrides) {
    return super.deploy(name, symbol, escrowFactory, overrides || {});
  }

  getDeployTransaction(name, symbol, escrowFactory, overrides) {
    return super.getDeployTransaction(name, symbol, escrowFactory, overrides || {});
  }

  attach(address) {
    return super.attach(address);
  }

  connect(signer) {
    return super.connect(signer);
  }

  static createInterface() {
    return new _ethers.utils.Interface(_abi);
  }

  static connect(address, signerOrProvider) {
    return new _ethers.Contract(address, _abi, signerOrProvider);
  }

}

exports.TradeTrustTokenMock__factory = TradeTrustTokenMock__factory;

_defineProperty(TradeTrustTokenMock__factory, "bytecode", _bytecode);

_defineProperty(TradeTrustTokenMock__factory, "abi", _abi);